import type { Cancellable } from '../../types';
import type { AppDispatch } from '../Store';
import type { ThunkAction } from '@reduxjs/toolkit';

import { fetchProfileDetails, fetchProfileLeaderboard, fetchProfileSummary } from '.';

const cancellableActions: { [key: string]: Cancellable } = {};

// For actions with no parameters
export function dispatchCancellableAction<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends (...args: any[]) => ThunkAction<any, any, any, any>,
>(dispatch: AppDispatch, action: T): void;
// For actions with parameters
export function dispatchCancellableAction<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends (...args: any[]) => ThunkAction<any, any, any, any>,
>(dispatch: AppDispatch, action: T, params: Parameters<T>[0]): void;

export function dispatchCancellableAction<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends (...args: any[]) => ThunkAction<any, any, any, any>,
>(dispatch: AppDispatch, action: T, params?: Parameters<T>[0]) {
  cancellableActions[action.name] = dispatch(params === undefined ? action() : action(params));
}

export function cancelProfileActions() {
  cancellableActions[fetchProfileSummary.name]?.abort();
  cancellableActions[fetchProfileDetails.name]?.abort();
  cancellableActions[fetchProfileLeaderboard.name]?.abort();
}

export function getProfileType(isPublic: boolean): 'public' | 'private' {
  return isPublic ? 'public' : 'private';
}
